import React, { useEffect, useState } from 'react'
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import { MetaData, labelMappings } from '../../../utils/utils';
import { PeiceCaseSwitchType } from '../../../types';
import { applyCaseFilter, applyPieceFilter } from '../MarketDetails/configData';
import { updateQuantityUnit, updateSlabInfoQuantityUnit } from '../../../../../stateManagement/actions/manageCouponActions';
import store from '../../../../../stateManagement/store';

function PeiceCaseSwitch(props:PeiceCaseSwitchType) {
    const {onChange,value} = props;
    const peiceVal = labelMappings['quantity-unit-value-piece'];
    const caseVal = labelMappings['quantity-unit-value-case'];
    const [val , setVal] = useState(value);
    useEffect(()=>{
        setVal(value)
    },[value]);
    useEffect(()=>{
        if((!applyPieceFilter() || !applyCaseFilter())){
            let quantityUnitt=applyPieceFilter()?labelMappings["quantity-unit-value-piece"]:labelMappings["quantity-unit-value-case"]
            updateQuantityUnit(quantityUnitt);
            updateSlabInfoQuantityUnit(quantityUnitt);
        }
       
    },[]);

  return (
    <div className='value-qty-switch-wrapper'>
        {
            applyPieceFilter() && <span className={`value-qty-switch ${val===peiceVal?'value-qty-switch-active':''}`} onClick={()=>onChange(peiceVal)}>
            <CouponConfigurableLabel text='piece' style={{cursor:'inherit',color:'inherit'}}/>
            </span>
        }
        {
            applyCaseFilter() &&  <span className={`value-qty-switch ${val===caseVal?'value-qty-switch-active':''}`}onClick={()=>onChange(caseVal)}>
            <CouponConfigurableLabel text='case' style={{cursor:'inherit',color:'inherit'}}/>
            </span>
        }
       
    </div>
  )
}

export default PeiceCaseSwitch